export default __webpack_public_path__ + "static/media/icon-whistle.1b2639d7.svg";